namespace Portico.Services {
    import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
	import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface ISurveyService {
		get: (id: number) => angular.IPromise<pme.Survey>;
		populate_session(programId: number, account: pme.Account, surveyIds: number[]): angular.IPromise<boolean>;
        saveSurveySession: (surveySession: pme.SurveySession) => angular.IPromise<number>;
    }

    @Service('app', 'surveyService')
	@Inject('$q', 'SurveyV2Api')
    export class SurveyService implements ISurveyService {
        constructor(
            private $q: angular.IQService,
			private surveyV2Api: psga.SurveyV2Api
        ) { }

		get(id: number): angular.IPromise<pme.Survey> {
			// let survey: pme.Survey = this.storageService.getItem<pme.Survey>(pm.StorageType.Session, `survey-${id}`);

			const promise = // survey ?
				// this.$q.when(survey) :
				this.$q.when(this.surveyV2Api.fullSurveyGet(id.toString(), '', '').then(response => {
					return response.data.data;
				}));

			return promise.then((response: any) => {
				// survey = new pme.Survey(response);
				// this.storageService.saveItem<pme.Survey>(pm.StorageType.Session, `survey-${id}`, survey);
				// return survey;
				return new pme.Survey(response);
			});
        }

		populate_session(programId: number, account: pme.Account, surveyIds: number[]): angular.IPromise<boolean> {
			const promises: angular.IPromise<void>[] = [];

			for (const surveyId of surveyIds) {
				const accountSessions = account.accountSessions.filter((a) => {
					return a.surveySessionId && a.surveyId === surveyId;
				}).sort((a, b) => {
					return b.sessionDate.getTime() - a.sessionDate.getTime();
				});

				if (accountSessions.length > 0) {
					const accountSession = accountSessions[0];

					// TODO: wrap in an edge call
					const promise = this.$q.when(this.surveyV2Api.fullSurveySessionGet3(accountSession.surveySessionId.toString(), programId.toString(), '5').then((response: any) => {
						accountSession.surveySession = new pme.SurveySession();

						for (const answer of response.data.data) {
							accountSession.surveySession.surveySessionAnswers.push(new pme.SurveySessionAnswer(answer));
						}
					}));

					promises.push(promise);
				}
			}

			return this.$q.all(promises).then(() => {
				return true;
			});
		}

		saveSurveySession(surveySession: pme.SurveySession): angular.IPromise<number> {
			const request: psgm.SurveySessionPostRequest = {
				surveyId: surveySession.surveyId,
				surveySourceId: surveySession.surveySourceId,
				sourceSystemId: ''
			};

			return this.$q.when(this.surveyV2Api.surveySessionCreate2('', '', request).then((response: any) => {
				const request2: psgm.FullSurveySessionPostRequest = {
					sessionValues: []
				}

				surveySession.surveySessionAnswers.forEach((ssa) => {
					const sessionValue: psgm.SurveySessionValuePostRequest = {
						surveySessionId: response.data.data.surveySessionId,
						questionId: ssa.questionId,
						answerId: ssa.answerId,
						answerValue: ssa.answerValue
					};

					request2.sessionValues.push(sessionValue);
				});

				// TODO: wrap in an edge call
				return this.surveyV2Api.fullSurveySessionCreate2('', '', request2).then((response2) => {
					surveySession.surveySessionId = response.data.data.surveySessionId;
					return response.data.data.surveySessionId;
				});
			}));
        }
    }
}